"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _unistUtilVisit = _interopRequireDefault(require("unist-util-visit"));

var _Matcher2 = _interopRequireDefault(require("./lib/Matcher"));

/* eslint-disable no-param-reassign */
var transformer = function transformTree(tree) {
  var transform = function transformNode(node, parent) {
    var children = node.children;

    if (children) {
      for (var i = 0; i < children.length; i += 1) {
        transform(children[i], node);
      }

      return;
    }

    var value = node.value;

    var _Matcher = new _Matcher2["default"](node.value),
        matches = _Matcher.matches;

    if (matches.length) {
      var _children = [];

      for (var _i = 0; _i < matches.length; _i += 1) {
        var match = matches[_i];

        _children.push({
          type: 'text',
          value: value.substring(0, match.start)
        });

        _children.push({
          type: match.tag,
          children: [{
            type: 'text',
            value: value.substring(match.start + 1, match.end)
          }]
        });

        _children.push({
          type: 'text',
          value: value.substring(match.end + 1)
        });

        parent.children = _children;
      }
    }
  };

  (0, _unistUtilVisit["default"])(tree, 'root', function (node) {
    transform(node);
  });
};

var remarkSubSup = function remarkSubSupPlugin() {
  return transformer;
};

var _default = remarkSubSup;
exports["default"] = _default;